/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_And_Register_MessageInputs */



/**
* | output |
* | --- |
* | "Create an Archon account and register for this tournament. An invite email will be sent." |
*
* @param {Create_And_Register_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_and_register_message = /** @type {((inputs?: Create_And_Register_MessageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_And_Register_MessageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un compte Archon et inscrire au tournoi. Un e-mail d'invitation sera envoyé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear una cuenta en Archon e inscribir en este torneo. Se enviará un correo de invitación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar uma conta no Archon e inscrever neste torneio. Um e-mail de convite será enviado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un account Archon e iscrivilo a questo torneo. Verrà inviata un'email di invito.")
	return /** @type {LocalizedString} */ ("Create an Archon account and register for this tournament. An invite email will be sent.")
});